import { CircularProgress, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { ApiModulesConfig } from '@shared/interfaces/ApiInterfaces';
import { useEffect, useState } from 'react';
import BackendApiService from 'services/BackendApiService';
import { getAccessToken } from 'utils/accessTokenStore';

export default function AdminPage() {
  const [modules, setModules] = useState<ApiModulesConfig[]>([]);
  const [loading, setLoading] = useState<any>({});
  const [pageLoading, setPageLoading] = useState<boolean>(true);
  const [errors, setErrors] = useState<{ [key: string]: boolean }>({});

  const [accessToken] = useState(() => {
    return getAccessToken();
  });

  const fetchModulesConfig = async () => {
    const backendApiService = new BackendApiService(accessToken ?? '');
    setModules(await backendApiService.getModulesConfig());
    setPageLoading(false);
  };

  useEffect(() => {
    fetchModulesConfig();
  }, []);

  const handleUpdateVersion = async (module: ApiModulesConfig, newValue: string | null) => {
    if (!newValue) {
      setErrors((prev) => ({ ...prev, [module.name]: true }));
      return;
    }

    setLoading((prev: any) => ({ ...prev, [module.name]: true }));
    const backendApiService = new BackendApiService(accessToken ?? '');

    await backendApiService.updateModulesConfig({ ...module, version: newValue });
    await fetchModulesConfig();

    setLoading((prev: any) => ({ ...prev, [module.name]: false }));
    setErrors((prev) => ({ ...prev, [module.name]: false }));
  };

  return (
    <div className="content-surface">
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><strong>Title</strong></TableCell>
              <TableCell><strong>Module</strong></TableCell>
              <TableCell><strong>Version</strong></TableCell>
              <TableCell><strong>Latest Available Version</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {modules.map((module) => (
              <TableRow
                key={`${module.name}-${module.platform}-${module.title}`}
                sx={{ backgroundColor: module.version !== module.latestAvailableVersion ? '#ffd81b75' : 'inherit' }}
              >
                <TableCell>{module.title}</TableCell>
                <TableCell>{module.platform}/{module.name}</TableCell>
                <TableCell>
                  <Autocomplete
                    options={module.allVersions}
                    value={module.version}
                    onChange={(event, newValue) => handleUpdateVersion(module, newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        error={errors[module.name]}
                        helperText={errors[module.name] ? 'Bitte mindestens ein Element ausählen.' : ''}
                        disabled={loading[module.name]}
                        sx={{ minWidth: 250, '& .MuiInputBase-input': { fontSize: '10pt' } }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loading[module.name] ? <CircularProgress size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </TableCell>
                <TableCell>{module.latestAvailableVersion}</TableCell>
              </TableRow>
            ))}

            {
              pageLoading && [0, 1, 2].map(i => (
                <TableRow
                  key={i}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell><Skeleton height={30} /></TableCell>
                  <TableCell><Skeleton height={30} /></TableCell>
                  <TableCell><Skeleton width={30} height={30} variant="circular" /></TableCell>
                  <TableCell><Skeleton width={30} height={30} variant="circular" /></TableCell>
                </TableRow>
              ))
            }

          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
